"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmountComponentsAtNodes = void 0;
// (C) 2019-2022 GoodData Corporation
var react_dom_1 = require("react-dom");
function unmountComponentsAtNodes(elementsOrSelectors, _a) {
    if (elementsOrSelectors === void 0) { elementsOrSelectors = []; }
    var _b = _a === void 0 ? {
        unmount: react_dom_1.unmountComponentAtNode,
        documentInstance: document,
    } : _a, unmount = _b.unmount, documentInstance = _b.documentInstance;
    elementsOrSelectors.forEach(function (elementOrSelector) {
        var element = typeof elementOrSelector === "string"
            ? documentInstance.querySelector(elementOrSelector)
            : elementOrSelector;
        if (element) {
            unmount(element);
        }
    });
}
exports.unmountComponentsAtNodes = unmountComponentsAtNodes;
//# sourceMappingURL=domHelper.js.map